import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Palette, Target, ShieldCheck } from 'lucide-react';
const steps = [{
  id: 'CREAR',
  title: 'Tu empresa registrada y en orden.',
  icon: <FileText className="w-8 h-8 text-inkova-primary" data-id="element-281" />,
  desc: 'Te acompañamos en el proceso de registrar tu LLC, obtener tu EIN y presentar todo correctamente ante Sunbiz.',
  note: 'Inkova gestiona y coordina el proceso de registro de tu empresa. No somos un despacho de abogados.'
}, {
  id: 'CONSTRUIR',
  title: 'Estructura, modelo y dirección clara.',
  icon: <Palette className="w-8 h-8 text-inkova-primary" data-id="element-282" />,
  desc: 'Tu negocio necesita una base: saber cómo opera, cómo cobra, cómo se organiza y qué responsabilidades tiene.'
}, {
  id: 'POSICIONAR',
  title: 'Identidad + presencia digital.',
  icon: <Target className="w-8 h-8 text-inkova-primary" data-id="element-283" />,
  desc: 'Te ayudamos a construir tu identidad corporativa y tu presencia digital lista para atraer clientes.'
}, {
  id: 'SOSTENER',
  title: 'Cumplimiento anual + acompañamiento.',
  icon: <ShieldCheck className="w-8 h-8 text-inkova-primary" data-id="element-284" />,
  desc: 'Te acompañamos en el cumplimiento anual para que tu empresa siga operando sin interrupciones.'
}];
const duplicatedSteps = [...steps, ...steps];
export function ProcessSection() {
  return <section id="proceso" className="py-20 bg-white relative overflow-hidden" data-id="element-285">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 mb-12" data-id="element-286">
        <div className="text-center max-w-3xl mx-auto" data-id="element-287">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-serif text-inkova-primary mb-4" data-id="element-288">
            En Inkova trabajamos en 4&nbsp;etapas&nbsp;naturales.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-lg md:text-xl font-light text-gray-600" data-id="element-289">
            Porque un negocio no se crea de golpe. Se
            construye&nbsp;con&nbsp;orden.
          </motion.p>
        </div>
      </div>

      {/* Horizontal auto-scrolling carousel */}
      <div className="relative group" data-id="element-290">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-291"></div>
        <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-292"></div>

        <div className="flex gap-6 animate-scroll-process group-hover:[animation-play-state:paused]" style={{
        width: 'max-content',
        willChange: 'transform'
      }} data-id="element-293">
          {duplicatedSteps.map((step, i) => <div key={i} className="flex-shrink-0 w-[280px] sm:w-[300px] md:w-[320px]" data-id="element-294">
              <div className="bg-inkova-light rounded-2xl p-6 border border-inkova-accent/20 shadow-sm h-full relative overflow-hidden" data-id="element-295">
                <div className="absolute top-0 right-0 bg-inkova-primary text-inkova-accent font-bold px-4 py-1 rounded-bl-xl text-xs uppercase tracking-widest" data-id="element-296">
                  ETAPA {i % steps.length + 1}
                </div>

                <div className="w-14 h-14 rounded-xl bg-white flex items-center justify-center mb-4 shadow-sm border border-inkova-accent/30" data-id="element-297">
                  {step.icon}
                </div>

                <h3 className="text-lg font-serif font-bold text-inkova-primary mb-1" data-id="element-298">
                  {step.id}
                </h3>
                <h4 className="text-sm font-medium text-gray-800 mb-3" data-id="element-299">
                  {step.title}
                </h4>
                <p className="text-sm text-gray-600 leading-relaxed font-light" data-id="element-300">
                  {step.desc}
                </p>

                {step.note && <p className="text-[11px] text-gray-400 italic mt-3 pt-3 border-t border-gray-200" data-id="element-301">
                    {step.note}
                  </p>}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}